
import React, { useContext, useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import search from "../../assets/img/sreach---icon.svg"
import l2 from "../../assets/img/l2.svg"
import userpls from "../../assets/img/user-plus.svg"
import profileimg from "../../assets/img/profile/profile-img.svg"
import { getCommunity } from "../../services/apiProfile";
import { ApiHelper } from "../../helpers/ApiHelper";
import { API } from "../../services/api";
import CreateCommunity from "./popups/CreateCommunity";
import LeaveCommunity from "./popups/LeaveCommunity";
import JoinACommunity from "./popups/JoinACommunity";
import "../../assets/css/joincommunityyy.css";
import ResponseCommunityPopup from "./popups/ResponseCommunityPopup";
import { createCommunity } from "../../services/apiCommunity";
import CreatePost from "../Posts/CreatePost";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
import { CommunityContext } from "../../config/CommunityContext";
import DeleteAccount from "../Profile/DeleteAccount";

const JoinCommunity = () => {
  const { fetchAllCommunities, communities } = useContext(CommunityContext);
  const [userId, setUserId] = useState('');
  const [topCommunityArr, setTopCommunityArr] = useState([]);
  const [communityArr, setCommunityArr] = useState([]);
  const [community, setCommunity] = useState('');
  const [communityId, setCommunityId] = useState('');
  const [communitySelected, setCommunitySelected] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [isNewCommunity, setIsNewCommunity] = useState(false);
  const handleClose = () => setIsNewCommunity(false);
  const [isLeaveCommunity, setIsLeaveCommunity] = useState(false);
  const handleLeaveClose = () => setIsLeaveCommunity(false);
  const [isJoinCommunity, setIsJoinCommunity] = useState(false);
  const handleJoinClose = () => setIsJoinCommunity(false);
  const [selectedCommunity, setSelectedCommunity] = useState(null);
  const [isSucess, SetSucess] = useState(false);
  const [ResponseMessage, SetResponseMessage] = useState("");
  const user = JSON.parse(localStorage.getItem('userData'));
  const [isCreatePostOpen, setIsCreatePostOpen] = useState(false);
  const [isDeleteAccount, setIsDeleteAccount] = useState(false);
  const handleDeleteAccountClose = () => setIsDeleteAccount(false);
  const [joinArr, setJoinArr] = useState([]);


  useEffect(() => {
    setUserId(user._id)
    getTopCommunities();
  }, [])
  useEffect(() => {

    getTopCommunities()
  }, [communityId])
  const getTopCommunities = async () => {
    const formData = {
      usereid: user._id,
      communityid: communityId ? communityId : ""
    }
    let topCommunity = await getCommunity(formData);
    setTopCommunityArr(topCommunity.communities);
    const joinedCommunities = topCommunity.communities.filter(item => item.isJoinedCommunity === 1);
    setJoinArr(joinedCommunities)

  }
  useEffect(() => {
    if (community !== '') {
      getAllCommunities(community)
    }
    else {
      setCommunityArr([])
      setCommunityId("")
      getTopCommunities()
    }
  }, [community])


  const getAllCommunities = async (community) => {
    setHasSearched(false);
    const formData = {
      searchkey: community,
      hasrecommendedcommunity: false
    }
    try {
      await ApiHelper.post(API.getAllCommunities, formData)
        .then((resData) => {
          setCommunityArr(resData.data.data)
          if (resData.data.data.length === 0 && community !== '') {
            setTimeout(() => {
              setHasSearched(true);
            }, 300);
          }
        })
        .catch((err) => {
          console.log(err, 'err');
        });
    }
    catch (err) {
      console.log(err);
    } finally {

    }
  }

  const RequestCommunity = async (payload) => {
    let response = await createCommunity(payload);
    if (response.status === true) {
      if (response.status) {
        await fetchAllCommunities({ userid: user._id });
      }
      //SetResponseMessage(response.message);
      SetResponseMessage(response.pendingCommunities[0]?.communityName)
      SetSucess(true);
    }

    handleClose();
  }

  return (
    <div >
      <div class="container-fluid">
        <div class="row">
          <div className="hd-breadcums">
            <h3 className="main-heading">Communities</h3>            
          </div>
          <div class="">
            <div class="row">

              <div class="col-lg-4 my-2 ">
                <form className=" search-section  position-relative ">
                  <div class=" d-flex ">
                    <div class=" search-box search-wrapper  d-flex align-items-center px-2 gap-2">
                      <span className="mobil-view-class border-end-0 ">
                        <img src={search} alt="search--Logo" className="search-logo-header mob-view-class pagess" />
                      </span>
                      <input type="text" class=" form-control border-start-0 search-inputs search-inside-color"
                        placeholder="Search here"
                        id="exampleFormControlInput1"
                        value={community}
                        onChange={(e) => {
                          e.preventDefault();
                          setCommunity(e.target.value);
                          setCommunitySelected(true);
                        }}
                        autoComplete="off" />

                    </div>
                  </div>
                  {hasSearched && (
                    <div className="col-lg-12 my-2 ">
                    <div className="link-box mt-2 d-flex align-items-center px-3 ">
                      <Link onClick={() => setIsNewCommunity(true)} className="text-primary text-decoration-underline">
                        I don't see my Community listed
                      </Link>
                    </div>
                    </div>
                  )}

                  {communityArr.length > 0 && communitySelected && (
                    <div className="col-lg-4 my-2 ">
                    <ul className="drop-div-join list-group mt-1 responsive-dropdown">
                      {communityArr.map((item, index) => (
                        <li key={index} className="list-group-item d-flex align-items-center">
                          <input
                            type="radio"
                            name="communityOption"
                            id={`option-${index}`}
                            value={item._id}
                            checked={community === item.communityName}
                            onChange={(e) => {
                              e.preventDefault();
                              setCommunity(item.communityName);
                              setCommunityId(item._id);
                              setCommunitySelected(false);
                            }}
                            className="form-check-input me-2"
                          />
                          <label htmlFor={`option-${index}`} className="form-check-label w-100 mb-0">
                            {item.communityName}
                          </label>
                        </li>
                      ))}
                    </ul>
                    </div>
                  )}
                </form>
              </div>



              
              <div className="">
                <div className="row">
                  {topCommunityArr.map((community, index) => (
                    <div className="col-md-6 col-lg-4 mb-3" key={index}>
                      <div className="community-card d-flex justify-content-between align-items-center p-2">
                        <div className="d-flex align-items-center gap-2">
                          <img
                            src={community?.communities?.profileImage?.url ? API.uploadFilePath + community?.communities?.profileImage.url : profileimg}
                            alt="Avatar"
                            className="community-img"
                          />
                          <span className="community-name-join text-truncate">{community?.communities?.communityName}</span>
                        </div>

                        {community.isJoinedCommunity === 1 ? (
                          <div className="d-flex align-items-center ">
                            <button className="btn joined-btn-comms px-3 py-1">Joined</button>
                            <button className="btn dots-btn" onClick={() => { setSelectedCommunity(community); setIsLeaveCommunity(true); }}>&#8942;</button>
                          </div>
                        ) : (
                          
                          <button className="btn join-btn-comms d-flex align-items-center gap-1 py-1" onClick={() => { setSelectedCommunity(community); setIsJoinCommunity(true); }}>
                            <img src={userpls} alt="Join" className="join-icon" />
                            Join now
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div> 





            </div>
          </div>
          {isNewCommunity ? <CreateCommunity isNewCommunity={isNewCommunity} handleClose={handleClose} /> : null}

          {communities.length > 1 ?
            isLeaveCommunity ? <LeaveCommunity isLeaveCommunity={isLeaveCommunity} handleClose={handleLeaveClose} community={selectedCommunity} getCommunity={getTopCommunities} /> : null
            : <DeleteAccount isLeaveCommunity={isLeaveCommunity} handleClose={handleLeaveClose} />}

          {isNewCommunity ? <CreateCommunity isNewCommunity={isNewCommunity} handleClose={handleClose} RequestCommunity={RequestCommunity} /> : null}
          {isJoinCommunity && selectedCommunity ? <JoinACommunity isJoinCommunity={isJoinCommunity} handleClose={handleJoinClose} community={selectedCommunity} getCommunity={getTopCommunities} openCreatePost={() => setIsCreatePostOpen(true)} /> : null}
          <CreatePost openPop={isCreatePostOpen} closePop={() => setIsCreatePostOpen(false)}></CreatePost>
          {isSucess && (<ResponseCommunityPopup
            isSucess={isSucess}
            CancelPopup={() => {
              SetSucess(false);
            }}
            message={ResponseMessage}
          />)}
        </div>
      </div>
    </div>
  );

};
export default JoinCommunity;
